import "core-js/modules/es.array.push.js";
import { ref, shallowRef } from '@vue/reactivity';
import AMapLoader from "@amap/amap-jsapi-loader";
import Config from '@/config';
import RouterUtil from "@/utils/RouterUtil";
import NavBar from "@/view/components/nav-bar/nav-bar.vue";
import StorageUtil from "@/utils/StorageUtil";
import AMapUtil from "@/utils/AMapUtil";
export default {
  name: "AddressMapSelect",
  components: {
    NavBar
  },
  setup() {
    const title = ref("选择位置");
    const map = shallowRef();
    const geolocation = shallowRef();
    const geocoder = shallowRef();
    const placeSearch = shallowRef();
    const placeNearSearch = shallowRef();
    const positionMarker = shallowRef();
    const poiPinMarker = shallowRef();
    const position = ref();
    const cityName = ref("");
    const cityCode = ref("");
    const showPin = ref(true);
    const noQueryAddress = ref(false);
    const addressType = ref("start");
    const keyword = ref("");
    const pois = ref([]);
    const searchPois = ref([]);
    const showAddress = ref("");
    const selectPodId = ref("");
    return {
      title,
      map,
      geolocation,
      geocoder,
      placeSearch,
      placeNearSearch,
      positionMarker,
      poiPinMarker,
      position,
      cityName,
      cityCode,
      showPin,
      noQueryAddress,
      addressType,
      keyword,
      pois,
      searchPois,
      showAddress,
      selectPodId
    };
  },
  mounted() {
    this.getStorageData();
    this.initMap();
  },
  unmounted() {
    if (this.map) {
      this.map.destroy();
    }
  },
  computed: {
    inputPlaceholder() {
      return this.getInputPlaceholder();
    }
  },
  methods: {
    initMap() {
      const that = this;
      window._AMapSecurityConfig = {
        securityJsCode: '23ca323d154479c363c8c8df0b1ddb92'
      };
      AMapLoader.load({
        key: Config.mapKey,
        // 申请好的Web端开发者Key，首次调用 load 时必填
        version: Config.mapVersion,
        // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [
        // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        "AMap.Geocoder", "AMap.Geolocation", "AMap.PlaceSearch"]
      }).then(AMap => {
        this.map = new AMap.Map("address-map-select-map", {
          //设置地图容器ID
          viewMode: "2D",
          //是否为3D地图模式
          zoom: 16,
          //初始化地图级别
          center: this.position //初始化地图中心点位置
          // mapStyle: "amap://styles/macaron",               //地图样式
        });
        this.geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,
          //是否使用高精度定位，默认:true
          timeout: 10000,
          //超过10秒后停止定位，默认：5s
          //position: 'RB',                         //定位按钮的停靠位置
          //offset: [10, 20],                       //定位按钮与设置的停靠位置的偏移量，默认：[10, 20]
          zoomToAccuracy: true //定位成功后是否自动调整地图视野到定位点
        });
        this.geocoder = new AMap.Geocoder({
          // city: "010",                            //城市设为北京，默认：“全国”
          // radius: 1000                            //范围，默认：500
        });
        this.placeSearch = new AMap.PlaceSearch({
          //设置PlaceSearch属性
          city: "",
          //城市
          type: "",
          //数据类别
          pageSize: 30,
          //每页结果数,默认10
          pageIndex: 1,
          //请求页码，默认1
          extensions: "base" //返回信息详略，默认为base（基本信息）
        });
        this.placeNearSearch = new AMap.PlaceSearch({
          //设置PlaceSearch属性
          city: "",
          //城市
          type:
          //数据类别
          "",
          pageSize: 30,
          //每页结果数,默认10
          pageIndex: 1,
          //请求页码，默认1
          extensions: "base" //返回信息详略，默认为base（基本信息）
        });
        this.map.on('movestart', function () {
          if (!that.noQueryAddress) {
            if (!that.showPin) {
              that.showPin = true;
            }
          }
        });
        this.map.on('moveend', function () {
          // that.position = [that.map.getCenter().getLng(), that.map.getCenter().getLat()];
          const x = window.innerWidth / 2;
          const y = 128 + 36;
          that.position = that.map.containerToLngLat([x, y]);
          if (!that.noQueryAddress) {
            that.getAddress(that.position);
          }
          that.noQueryAddress = false;
        });
        this.getAddress(this.position);
        this.positionMarker = new AMap.Marker({
          position: this.position,
          // offset: new AMap.Pixel(-10, -12),
          visible: false
        });
        this.map.add(this.positionMarker);
        this.noQueryAddress = true;
        const mapBottom = this.$refs.card.offsetHeight + 40 + 122;
        this.map.setFitView(null, false, [0, mapBottom, 0, 0], Config.defaultMapZoom);
      }).catch(e => {
        console.error(e);
      });
    },
    getAddress(position) {
      const that = this;
      AMapUtil.getAddress(this.geocoder, position).then(function (result) {
        if (result.districtName.endsWith("市") || result.districtName.endsWith("县")) {
          that.placeSearch.setCity(result.adCode);
        } else {
          that.placeSearch.setCity(result.cityCode);
        }
        that.cityCode = result.adCode;
        that.cityName = result.cityName;
        that.showAddress = result.showAddress;
        that.goPlaceSearchNearBy();
      }).catch(function (error) {
        that.cityName = "未知地区";
        console.error('根据经纬度查询地址失败：' + error);
      });
    },
    goPlaceSearch() {
      if (this.keyword.length === 0) {
        return;
      }
      const that = this;
      that.placeSearch.search(that.keyword, function (status, result) {
        if (status === "complete") {
          const poiData = result.poiList.pois;
          that.searchPois = [];
          for (let i = 0; i < poiData.length; i++) {
            that.searchPois.push(poiData[i]);
          }
        }
      });
    },
    goPlaceSearchNearBy() {
      const that = this;
      let apiSearch = that.placeSearch;
      let radius = 200;
      if (that.addressType === "end") {
        apiSearch = that.placeNearSearch;
        radius = 200;
      }
      apiSearch.searchNearBy("", this.position, radius, function (status, result) {
        if (status === "complete") {
          const poiData = result.poiList.pois;
          that.pois = [];
          for (let i = 0; i < poiData.length; i++) {
            that.pois.push(poiData[i]);
          }
        }
      });
    },
    selectAddress(index) {
      StorageUtil.setObject("addressData", {
        type: this.addressType,
        cityName: this.cityName,
        address: this.pois[index].name,
        position: this.pois[index].location
      });
      RouterUtil.back();
    },
    getStorageData() {
      try {
        this.position = Config.defaultPosition;
        const settingData = StorageUtil.getObject("settingData");
        if (settingData) {
          this.setting = settingData;
        }
        const positionData = StorageUtil.getObject("positionData");
        if (positionData) {
          if (positionData.type) {
            this.addressType = positionData.type;
          }
          if (positionData.position) {
            this.position = positionData.position;
          }
        }
      } catch (e) {} finally {
        // StorageUtil.remove("positionData");
        if (this.addressType === 'start') {
          this.title = "选择上车点位置";
        }
        if (this.addressType === 'end') {
          this.title = "选择下车点位置";
        }
        if (this.addressType === 'home') {
          this.title = "选择住宅位置";
        }
        if (this.addressType === 'work') {
          this.title = "选择公司位置";
        }
        StorageUtil.remove("positionData");
      }
    },
    goBack() {
      RouterUtil.back();
    },
    goHome() {
      RouterUtil.home();
    },
    goSelectCity(type) {
      // StorageUtil.setObject("positionData", {
      //     type: type,
      //     position: this.position,
      // });
      RouterUtil.go("/city", false, this.$route.path);
    },
    selectPoi(index) {
      this.selectPodId = this.pois[index].id;
      this.noQueryAddress = true;
      this.position = [this.pois[index].location.getLng(), this.pois[index].location.getLat()];
      this.map.setCenter(this.position);
      this.showAddress = this.pois[index].name;
      this.showPin = false;
      if (this.poiPinMarker) {
        this.poiPinMarker.remove();
      }
      const lnglat = this.position;
      const driverIcon = new AMap.Icon({
        image: require('@/assets/icon/poi-pin.png'),
        size: [24, 24],
        imageSize: [24, 24]
      });
      this.poiPinMarker = new AMap.Marker({
        position: lnglat,
        icon: driverIcon,
        offset: new AMap.Pixel(-10, -12)
      });
      this.map.add(this.poiPinMarker);
      this.map.setFitView(null, false, [0, 320, 0, 0]);
    },
    selectSearchPoi(index) {
      this.selectPodId = this.searchPois[index].id;
      this.noQueryAddress = true;
      this.position = [this.searchPois[index].location.getLng(), this.searchPois[index].location.getLat()];
      this.map.setCenter(this.position);
      this.showAddress = this.searchPois[index].name;
      this.showPin = false;
      if (this.poiPinMarker) {
        this.poiPinMarker.remove();
      }
      const lnglat = this.position;
      const driverIcon = new AMap.Icon({
        image: require('@/assets/icon/poi-pin.png'),
        size: [24, 24],
        imageSize: [24, 24]
      });
      this.poiPinMarker = new AMap.Marker({
        position: lnglat,
        icon: driverIcon,
        offset: new AMap.Pixel(-10, -12)
      });
      this.map.add(this.poiPinMarker);
      this.map.setFitView(null, false, [0, 320, 0, 0]);
      this.keyword = "";
      this.pois = [];
    },
    enterSelect() {
      StorageUtil.setObject("addressData", {
        type: this.addressType,
        cityName: this.cityName,
        address: this.showAddress,
        position: this.position
      });
      RouterUtil.back();
    },
    getInputPlaceholder() {
      if (this.addressType === 'start') {
        return "您在哪里上车？";
      }
      if (this.addressType === 'end') {
        return "您要去哪里？";
      }
      return "输入关键字查询";
    }
  }
};